import i18n from '../../../i18n';

export const formatUsageLimit = (usageLimit?: number | null) => {
    switch (usageLimit) {
        case 0:
            return i18n.t('shop.subscriptions.unlimited');
        case undefined:
        case null:
            return '0';
        default:
            return `SIM-${usageLimit}`;
    }
};
